var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.994 1.89A1 1 0 0 1 11 2v1H2.5a.5.5 0 0 0-.492.41L2 3.5a.5.5 0 0 0 .41.492L2.5 4H12a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5l.003-.054L1 4.898V2.894a1 1 0 0 1 .889-.993l8-.894a1 1 0 0 1 1.105.882M11 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
  })));
};
export default SvgWallet;